import { IKeyContact } from './Cards/KeyContactsPanel';
import { SliderTile } from './Models/Tiles';

export async function GetSlider(): Promise<SliderTile[]> {
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/GetSlider');
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const resJson = await res.json();
      return resJson;
    } else {
      console.error('GetSlider');
      console.error(res.text());
    }
  } catch (err: any) {
    console.error('GetSlider');
    console.error(err.message);
  }
  return [];
}

//#region USER_FAVORITES
export async function GetFavorites(): Promise<IUserFavorite[]> {
  let list: IUserFavorite[] = [];
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/GetFavorites');
    let result = await res.json();
    result.forEach((item: any) => {
      let favoriteRec: IUserFavorite = {
        Id: item.Id,
      };
      list.push(favoriteRec);
    });
  } catch (err: any) {
    console.error('GetFavorites >> ' + err.message);
  }
  return list;
}

export async function GetKeyContacts(
  agencyNumber: string,
  state: string,
): Promise<{ Region: string; KeyContacts: IKeyContact[]; success: boolean } | null> {
  if (!agencyNumber) return null;
  try {
    let res = await fetch(`/api/sitecore/CustomerAsync/GetKeyContacts?agencyNumber=${agencyNumber}&state=${state}`);
    if (res) {
      let data: { Region: string; KeyContacts: IKeyContact[]; success: boolean } = await res.json();
      if (data.success) {
        return data;
      }
    }
  } catch (err) {
    console.error(err);
  }
  return null;
}

export async function AddFavorite(favorite: IUserFavorite): Promise<boolean> {
  let isSuccess: boolean = false;
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/AddFavorite', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userFavorite: favorite,
      }),
    });
    let result = await res.json();
    isSuccess = result as boolean;
  } catch (err: any) {
    console.error('AddFavorite >> ' + err.message);
  }
  return isSuccess;
}

export async function RemoveFavorite(favoriteId: string): Promise<boolean> {
  let isSuccess: boolean = false;
  let url = '/api/sitecore/NowNavigationAsync/DeleteFavorite?favoriteid=' + favoriteId;
  try {
    const res = await fetch(url, {
      method: 'DELETE',
    });
    let result = await res.json();
    isSuccess = result as boolean;
  } catch (err: any) {
    console.error('RemoveFavorite >> ' + err.message);
  }
  return isSuccess;
}

export type IUserFavorite = {
  Id: string;
};
//#endregion
